// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__Link from "../../../components/html/Link.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Buhta_models__Locale from "../../../../../../packages/models/Locale.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function NavbarMainItems(Props) {
  let menus = Props.menus;
  let setIdx = Props.setIdx;
  let setMobileMenuActive = Props.setMobileMenuActive;
  const country = Buhta_landing__Route.getCountry(undefined);
  const language = Buhta_landing__Route.getLanguage(undefined);
  const countryStr = Buhta_models__Locale.toCountryString(country);
  const languageStr = Buhta_models__Locale.toString(language);
  const intl = ReactIntl.useIntl();
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      Belt__Belt_List.toArray(Stdlib__List.mapi((function (index, i) {
        const url = "/" + countryStr + "/" + languageStr + Belt__Belt_Option.getWithDefault(i.link, "");
        const Key = "mobile_menu_" + String(index);
        return JsxRuntime.jsxs("div", {
          children: [
            i.type_ === "dropdown" ? JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: i.name,
                    className: "paragraph-large text-black-landing"
                  }),
                  JsxRuntime.jsx("img", {
                    alt: "dropdown",
                    src: StaticAsset.src("/static/icons/dropdown-right-20.svg")
                  })
                ],
                className: "py-2.5 flex justify-between",
                onClick: (function (param) {
                  Curry._1(setIdx, (function (param) {
                    return index;
                  }));
                })
              }) : JsxRuntime.jsx(Buhta_landing__Link.make, {
                route: Buhta_landing__Route.ofUrl(Buhta_landing__Route.getRouterUrl(url)),
                className: "py-2.5 flex justify-between",
                onLinkClicked: (function (param) {
                  Curry._1(setMobileMenuActive, (function (param) {
                    return false;
                  }));
                }),
                children: JsxRuntime.jsx("p", {
                  children: i.name,
                  className: "paragraph-large text-black-landing"
                })
              }),
            JsxRuntime.jsx("hr", {
              className: "text-divider"
            })
          ]
        }, Key);
      }), menus)),
      JsxRuntime.jsxs("span", {
        children: [
          JsxRuntime.jsx("img", {
            className: "mr-2",
            src: StaticAsset.src("/static/icons/tickets.svg")
          }),
          Buhta_landing__I18n.trans(intl, "help_center")
        ],
        className: "paragraph-small mt-6 flex py-3.5 text-gray-landing cursor-pointer border-b border-divider transition-all duration-200 ease-in-out hover:text-primary"
      }),
      JsxRuntime.jsxs("span", {
        children: [
          JsxRuntime.jsx("img", {
            className: "mr-2",
            src: StaticAsset.src("/static/icons/question.svg")
          }),
          Buhta_landing__I18n.trans(intl, "how_to_work_with_buhta")
        ],
        className: "paragraph-small flex py-3.5 text-gray-landing cursor-pointer border-b border-divider transition-all duration-200 ease-in-out hover:text-primary"
      }),
      JsxRuntime.jsxs(Buhta_landing__Link.make, {
        route: {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: /* Contact */ 7
        },
        className: "paragraph-small flex py-3.5 text-gray-landing cursor-pointer border-b border-divider transition-all duration-200 ease-in-out hover:text-primary",
        onLinkClicked: (function (param) {
          Curry._1(setMobileMenuActive, (function (param) {
            return false;
          }));
        }),
        children: [
          JsxRuntime.jsx("img", {
            className: "mr-2",
            src: StaticAsset.src("/static/icons/at.svg")
          }),
          Buhta_landing__I18n.trans(intl, "contacts")
        ]
      })
    ]
  });
}

const make = NavbarMainItems;

export {
  make,
}
/* Buhta_landing__Link Not a pure module */
